import type { Header } from "@tanstack/react-table";
import { ArrowUp, ArrowDown, ArrowUpDown } from "lucide-react";

export interface TableSortIconProps<T> {
  column: Header<T, unknown>["column"];
  size?: number;
}

export const TableSortIcon = <T,>({ column, size }: TableSortIconProps<T>) => {
  const sort = column.getIsSorted();

  if (sort === "asc") {
    return <ArrowUp size={size ?? 14} className="ml-1 text-blue-600" />;
  }

  if (sort === "desc") {
    return <ArrowDown size={size ?? 14} className="ml-1 text-blue-600" />;
  }

  return <ArrowUpDown size={size ?? 14} className="ml-1 text-gray-400" />;
};
